<script>
  import {
    addDefaultBanner,
    editDefaultBanner,
    getBannerTemList,
    judgeBannerTemp
  } from '../../../../api/bottomBannerDefault'
  import banner1 from './bannerTemplate/banner1.vue'
  import OperationButtons from './OperationButtons.vue'
  import BannerPreview from './BannerPreview.vue'
  import banner2 from './bannerTemplate/banner2.vue'
  import banner3 from './bannerTemplate/banner3.vue'
  import banner4 from './bannerTemplate/banner4.vue'

  export default {
    name: 'DefaultBanner',
    components: { banner1, OperationButtons, BannerPreview, banner2, banner3, banner4 },
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: {
        type: Object,
        default: () => ({
          name: '',
          adTemplateId: 1,
          displayChannelList: [],
          slotKey: ''
        })
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        form: {
          name: '',
          adTemplateId: '',
          displayChannelList: [],
          slotKey: ''
        },
        rules: {
          adTemplateId: [{ required: true, message: '请选择banner模板', trigger: 'change' }]
        },
        bannerTemplates: [
          { label: '1*4 banner 位', value: 1 },
          { label: '1*2 banner 位', value: 2 },
          { label: '2+1 banner 位', value: 3 },
          { label: '单行 banner 位', value: 4 }
        ],
        showVisible: false,
        slotKeys: [],
        useTabStyle: false,
        isEdit: false
      }
    },
    computed: {
      img() {
        const map = new Map([
          [1, require('@/assets/images/banner/banner1View.jpg')],
          [2, require('@/assets/images/banner/banner2View.jpg')],
          [3, require('@/assets/images/banner/banner3View.jpg')],
          [4, require('@/assets/images/banner/banner4View.jpg')]
        ])
        const { adTemplateId } = this.form
        return map.get(adTemplateId)
      },
      // 计算属性，用于解决直接修改props的问题
      dialogVisible: {
        get() {
          return this.visible
        },
        set(val) {
          this.$emit('update:visible', val)
        }
      }
    },
    created() {
      getBannerTemList().then((res) => {
        const { code, data } = res
        if (code === 0) {
          this.bannerTemplates = data.filter((item) => {
            return item.id !== 4
          })
          // 初始化数据
          const { adTemplateId, slotKey, adTemplateName } = this.value || {}
          if (adTemplateName) {
            const temp = this.bannerTemplates.find((item) => item.name === adTemplateName)
            this.$set(this.form, 'adTemplateId', temp.id)
            this.slotKeys = temp.slotKeys
          }
          if (adTemplateId && slotKey) {
            const temp = this.bannerTemplates.find((item) => item.id === adTemplateId)
            const slotKeys = temp ? temp.slotKeys : []
            if (Array.isArray(slotKeys) && slotKeys.length > 0) {
              this.slotKeys = slotKeys
            }
          }
        }
      })
    },
    watch: {
      value: {
        handler(val) {
          if (val) {
            const { isEdit, ...rest } = val
            this.form = JSON.parse(JSON.stringify(rest))
            this.isEdit = isEdit
          }
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      // 校验基本表单
      validateForm() {
        return new Promise((resolve, reject) => {
          this.$refs.defaultBannerForm.validate((valid) => {
            if (valid) {
              resolve(this.form)
            } else {
              // 表单验证失败
              reject(new Error('基本信息表单验证失败'))
            }
          })
        })
      },

      handleSubmit() {
        // 先校验基本表单
        this.validateForm()
          .then(() => {
            // 然后校验banner组件中的所有表单
            if (this.$refs.banner) {
              return this.$refs.banner.validateAllForms(this.slotKeys)
            }
            return this.form
          })
          .then((formData) => {
            const { adTemplateId, id } = this.form
            // 处理表单数据
            let dataToSubmit

            // 如果使用Tab风格，需要处理所有位置的数据
            if (this.useTabStyle && formData.allPositionsData) {
              // 准备提交的数据数组
              const submitDataArray = []

              // 遍历所有位置数据
              for (const slotKey in formData.allPositionsData) {
                const positionData = formData.allPositionsData[slotKey]

                // 确保该位置有数据且有必要的字段
                if (positionData && positionData.imgUrl) {
                  // 确保核心字段不被覆盖
                  submitDataArray.push({
                    ...positionData, // 该位置的特定数据
                    slotKey, // 确保slotKey正确
                    status: 1,
                    // name, // 使用form中的name
                    adTemplateId, // 使用form中的adTemplateId
                    id: this.isEdit ? id : undefined // 仅在编辑模式下使用id
                  })
                }
              }

              dataToSubmit = submitDataArray
            } else {
              // 确保核心字段不被覆盖
              dataToSubmit = [
                {
                  ...formData,
                  status: 1,
                  adTemplateId, // 使用form中的adTemplateId
                  id: this.isEdit ? id : undefined // 仅在编辑模式下使用id
                }
              ]
            }

            if (!this.isEdit) {
              return addDefaultBanner(dataToSubmit)
            } else {
              return editDefaultBanner({
                ...dataToSubmit[0],
                id // 确保id正确
              })
            }
          })
          .then((res) => {
            const { code } = res
            if (code === 0) {
              this.$message.success(this.isEdit ? '编辑默认banner成功！' : '新增默认banner成功！')
              this.closeDialog(false)
            }
          })
          .catch((error) => {
            // this.$message.error(error.message || '操作失败')
            console.error('表单校验失败:', error)
          })
      },

      closeDialog(hasConfirm = true, done) {
        if (hasConfirm) {
          this.$confirm('暂未保存内容，是否确认关闭?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            done && done()
            this.dialogVisible = false
            this.resetForm()
          })
        } else {
          this.dialogVisible = false
          this.resetForm()
          this.$emit('closeDialog')
        }
      },

      resetForm() {
        this.$refs.defaultBannerForm.resetFields()
      },

      adTemplateChange() {
        const item = this.bannerTemplates.find((item) => item.id === this.form.adTemplateId)
        this.slotKeys = item ? item.slotKeys : []
        this.form.slotKey = this.slotKeys[0] || ''

        judgeBannerTemp(this.form.adTemplateId).then((res) => {
          const { code, data } = res
          if (code === 0) {
            this.useTabStyle = !data
          }
        })
      },

      handlePrev() {
        if (this.$refs.banner) {
          this.$refs.banner.handlePrev()
        }
      },

      handleNext() {
        if (this.$refs.banner) {
          this.$refs.banner.handleNext()
        }
      },

      handleSaveDraft() {
        this.validateForm().then(() => {
          if (this.$refs.banner) {
            const allData = this.$refs.banner.getAllData()
            const catchData = allData.allPositionsData
            let submitData = []

            // 从form中提取核心字段，确保不被覆盖
            const { adTemplateId } = this.form

            if (this.useTabStyle) {
              for (const slotKey in catchData) {
                submitData.push({
                  ...catchData[slotKey],
                  adTemplateId, // 使用form中的adTemplateId
                  slotKey, // 确保slotKey正确
                  status: 0
                })
              }
            } else {
              const currentSlotKey = allData.currentSlotKey
              submitData = [
                {
                  ...catchData[currentSlotKey],
                  adTemplateId, // 使用form中的adTemplateId
                  slotKey: currentSlotKey, // 确保slotKey正确
                  status: 0
                }
              ]
            }

            addDefaultBanner(submitData).then((res) => {
              const { code } = res
              if (code === 0) {
                this.$message.success('保存草稿成功！')
                this.closeDialog(false)
              }
            })
          }
        })
      },

      beforeClose(done) {
        this.closeDialog(true, done)
      },

      closeEdit() {
        this.$confirm('暂未保存内容，是否确认关闭?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.dialogVisible = false
          this.resetForm()
        })
      }
    }
  }
</script>

<template>
  <yd-dialog
    :title="isEdit ? '编辑' : '新增'"
    :visible="dialogVisible"
    width="1250px"
    @close="beforeClose"
  >
    <div class="contain">
      <div class="left">
        <el-form
          ref="defaultBannerForm"
          :model="form"
          :rules="rules"
          label-width="120px"
          size="small"
        >
          <!--          <el-form-item label="名称" prop="name">-->
          <!--            <el-input-->
          <!--              v-model="form.name"-->
          <!--              placeholder="请输入广告名称"-->
          <!--              maxlength="30"-->
          <!--              show-word-limit-->
          <!--              style="width: 400px"-->
          <!--            />-->
          <!--          </el-form-item>-->

          <el-form-item label="banner 模板" prop="adTemplateId">
            <el-select
              v-model="form.adTemplateId"
              placeholder="模板一: 1*4 banner 位"
              style="width: 400px"
              @change="adTemplateChange"
              v-if="!isEdit"
            >
              <el-option
                v-for="item in bannerTemplates"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <div v-else>{{ form.adTemplateName }}</div>
          </el-form-item>
        </el-form>
        <banner1
          v-if="form.adTemplateId === 1"
          v-model="form"
          :slotKeys="slotKeys"
          :useTabStyle="useTabStyle"
          ref="banner"
          :isEdit="isEdit"
          :isDefaultBanner="true"
        />
        <banner2
          v-if="form.adTemplateId === 2"
          v-model="form"
          :slotKeys="slotKeys"
          :useTabStyle="useTabStyle"
          ref="banner"
          :isEdit="isEdit"
          :isDefaultBanner="true"
        />
        <banner3
          v-if="form.adTemplateId === 3"
          v-model="form"
          :slotKeys="slotKeys"
          :useTabStyle="useTabStyle"
          ref="banner"
          :isEdit="isEdit"
          :isDefaultBanner="true"
        />
        <banner4
          v-if="form.adTemplateId === 4"
          v-model="form"
          :slotKeys="slotKeys"
          :useTabStyle="useTabStyle"
          ref="banner"
          :isEdit="isEdit"
          :isDefaultBanner="true"
        />
      </div>
      <div class="right" v-if="form.adTemplateId">
        <banner-preview>
          <template #imgSlot>
            <div class="preview-img-container">
              <img :src="img" alt="Banner预览" class="preview-img" />
            </div>
          </template>
        </banner-preview>
      </div>
    </div>

    <div slot="footer" class="dialog-footer" v-if="!isEdit">
      <operation-buttons
        :current-index="$refs.banner ? $refs.banner.getCurrentIndex() : 0"
        :total-steps="slotKeys.length"
        @cancel="closeDialog"
        @save-draft="handleSaveDraft"
        @prev="handlePrev"
        @next="handleNext"
        @submit="handleSubmit"
        :show-prev="useTabStyle"
        :show-next="useTabStyle"
        :showSaveDraft="useTabStyle"
      />
    </div>
    <div slot="footer" class="dialog-footer" v-else>
      <el-button @click="closeEdit">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </div>
  </yd-dialog>
</template>

<style scoped lang="scss">
  .contain {
    display: flex;

    .left {
      flex: 1;
    }

    .right {
      width: 500px;
      margin-left: 20px;
    }
  }
  .preview-img-container {
    width: 300px;
    .preview-img {
      width: 100%;
    }
  }
</style>
